import { Component, Input, OnInit } from '@angular/core';
import { SchedulingService, ScheduledAction } from './scheduling.service';
import { UserDetailsService } from '../../shared/user.details.service';
import { ToasterService } from 'angular2-toaster';

@Component({
    selector: 'app-scheduling',
    templateUrl: 'scheduling.component.html'
})
export class SchedulingComponent implements OnInit {
    @Input() selectedTitle: any;
    private scheduledActions: ScheduledAction[];
    private loadingActions = true;
    private failedLoading = false;
    private createAction = false;

    private createScheduledAction: ScheduledAction;

    private ACTION_MAPPINGS = {
        'mapping-qa': 'Mapping QA'
    };
    private ACTION_MAPPINGS_LIST = Object.keys(this.ACTION_MAPPINGS);

    constructor(private schedulingService: SchedulingService,
        private userDetailsService: UserDetailsService,
        private toasterService: ToasterService) {}

    ngOnInit() {
        // Get the scheduled tasks for this title
        this.schedulingService.getScheduledActions(null, null, this.selectedTitle.parrot_id, null)
            .then((res) => {
                this.scheduledActions = res['scheduledActions'].map((item) => {
                    if (item.cancelledTimestamp) {
                        item.cancelledTimestamp = (new Date(item.cancelledTimestamp)).toLocaleDateString();
                    }
                    return item;
                });
                this.loadingActions = false;
            })
            .catch((err) => {
                this.toasterService.pop('Failed to load scheduled actions');
                this.failedLoading = true;
                console.error(err);
            });
    }

    resetState() {
        this.scheduledActions = [];
        this.loadingActions = true;
        this.failedLoading = false;
        this.createAction = false;
        this.createScheduledAction = undefined;
        this.ngOnInit();
    }

    handleDisplayCreate() {
        this.createAction = true;
        this.createScheduledAction = new ScheduledAction();
        this.createScheduledAction.user = this.userDetailsService.getUsername();
        this.createScheduledAction.parrotId = this.selectedTitle.parrot_id;
        this.createScheduledAction.action = this.ACTION_MAPPINGS_LIST[0];
        this.createScheduledAction.actionDate = new Date().toISOString().split('T')[0];
        this.createScheduledAction.completed = false;
    }

    handleCreateAction() {
        this.loadingActions = true;
        this.schedulingService.createScheduledAction(this.createScheduledAction)
            .then((res) => {
                this.toasterService.pop('success', 'Successfully created a scheduled action');
                this.resetState();
            })
            .catch((err) => {
                this.toasterService.pop('error', 'Failed to create scheduled action');
                console.error(err);
                this.loadingActions = false;
            });
    }

    handleCancelAction(action: ScheduledAction) {
        this.loadingActions = true;
        this.schedulingService.cancelScheduledAction(action.id, this.userDetailsService.getUsername())
            .then((res) => {
                this.toasterService.pop('success', 'Successfully cancelled a scheduled action');
                this.resetState();
            })
            .catch((err) => {
                this.toasterService.pop('error', 'Failed to cancel scheduled action');
                console.error(err);
                this.loadingActions = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/scheduling/scheduling.component.ts